import { withStyles } from '@material-ui/core';

import ShowcaseTooltip from './component';
import styles from './styles';

export default withStyles(styles)(ShowcaseTooltip);
